import { mapEnumToOptions } from '@abp/ng.core';

export enum MemberTypeCh {
  Particulier = 0,
  Professionnel = 1,
  NonRenseigne = -1,
}

export const memberTypeChOptions = mapEnumToOptions(MemberTypeCh);
